import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index';

import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';

class HeightDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            defaultValue: null,
            initialValues: this.getHeightMinAndMax(),
            heightValues: this.getHeightMinAndMax(),
        }
    }

    handleHeightChange = (event, newValue) => {
        this.setState({ heightValues: newValue });
        this.props.filterChange(FilterActions.HEIGHT, newValue);
    };

    handleClose = (event) => {
        this.props.filterChange(FilterActions.HEIGHT, this.state.defaultValue);
        this.props.closeCallback(event);
    }

    getHeightMinAndMax = () => {
        let min = 0;
        let max = 1;
        for (const figureData of Object.values(this.props.figuresData)) {
            const height = Math.abs(figureData.attributes.top_height - figureData.attributes.base_height);
            if (!height) continue;
            if (min > height) min = height;
            if (max < height) max = height;
        }
        return [min, max];
    }

    render() {
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Altura') } (mts)
                    <CloseIcon className='float-right cursor-pointer' data-type='height' onClick={this.handleClose}/>
                </p>
                <Grid container spacing={2}>
                    <Grid item>
                        {Math.round(this.state.initialValues[0])}
                    </Grid>
                    <Grid item xs>
                        <Slider
                            min={this.state.initialValues[0]}
                            max={this.state.initialValues[1]}
                            step={0.1}
                            value={this.state.heightValues}
                            onChange={this.handleHeightChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => value.toFixed(1)}
                        />
                    </Grid>
                    <Grid item>
                        {Math.round(this.state.initialValues[1])}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        figuresData : state.projectData.figures
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(HeightDropdown);